import React from "react";
import PropTypes from "prop-types"; // ES6

import { IconaError } from "../commons/Icones";
import PopOverGeneric from "../commons/PopOverGeneric";

const PopoverError = props => {
  const { contingut, titol, classNameIcona } = props;
  const iconaError = <IconaError className={classNameIcona} />;

  return (
    <PopOverGeneric
      titolPopover={titol}
      contingutPopover={contingut}
      elementBase={iconaError}
    />
  );
};

PopoverError.propTypes = {
  contingut: PropTypes.node,
  titol: PropTypes.node,
  classNameIcona: PropTypes.string
};

export default PopoverError;
